var TableGeneralGoModelToDataConverter = /** @class */ (function () {
    function TableGeneralGoModelToDataConverter(data) {
        this._stroke = data.stroke;
        this._splitLine = data.splitLine;
        this._fill = data.fill;
        this._isHiddenColumnSplitLine = data.isHiddenColumnSplitLine;
        this._isHiddenRowSplitLine = data.isHiddenRowSplitLine;
    }
    Object.defineProperty(TableGeneralGoModelToDataConverter.prototype, "stroke", {
        get: function () {
            return this._stroke;
        },
        set: function (v) {
            this._stroke = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralGoModelToDataConverter.prototype, "splitLine", {
        get: function () {
            return this._splitLine;
        },
        set: function (v) {
            this._splitLine = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralGoModelToDataConverter.prototype, "fill", {
        get: function () {
            return this._fill;
        },
        set: function (v) {
            this._fill = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralGoModelToDataConverter.prototype, "isHiddenColumnSplitLine", {
        get: function () {
            return this._isHiddenColumnSplitLine;
        },
        set: function (v) {
            this._isHiddenColumnSplitLine = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableGeneralGoModelToDataConverter.prototype, "isHiddenRowSplitLine", {
        get: function () {
            return this._isHiddenRowSplitLine;
        },
        set: function (v) {
            this._isHiddenRowSplitLine = v;
        },
        enumerable: true,
        configurable: true
    });
    return TableGeneralGoModelToDataConverter;
}());
export { TableGeneralGoModelToDataConverter };
